import React from 'react';
import { Link } from 'react-router-dom';
import './FeaturedProducts.css';

const FeaturedProducts = () => {
  const cards = [
    {
      id: 1,
      title: 'PRODUCTOS',
      price: 'Ver todo',
      image: 'https://images.pexels.com/photos/684965/pexels-photo-684965.jpeg?_gl=1*11qfd2t*_ga*MjAyMTI0OTYwOS4xNzY4OTI3NjE5*_ga_8JE65Q40S6*czE3NzIyODczNTIkbzExJGcxJHQxNzcyMjg3NTg3JGozMiRsMCRoMA..',
      to: '/categorias',
    },
    {
      id: 2,
      title: 'COMBOS',
      price: 'Ver combos',
      image: 'https://images.pexels.com/photos/31393439/pexels-photo-31393439.jpeg?_gl=1*xrytvp*_ga*MjAyMTI0OTYwOS4xNzY4OTI3NjE5*_ga_8JE65Q40S6*czE3NzIyODczNTIkbzExJGcxJHQxNzcyMjg3NjgxJGo1OSRsMCRoMA..',
      to: '/combos',
    },
  ];

  return (
    <section className="featured-products">
      <div className="container">
        <div className="featured-grid">
          {cards.map((card) => (
            <Link
              key={card.id}
              to={card.to}
              className="featured-card"
              aria-label={`Ir a ${card.title}`}
            >
              <div className="featured-image">
                <img src={card.image} alt={card.title} />
                <div className="featured-overlay">
                  <h3 className="featured-title">{card.title}</h3>
                  <p className="featured-price">{card.price}</p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedProducts;

